(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silhouette-guide-v2"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('sv2-silhouette-v2')){
class NESilhouetteGuide extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.sv2-card')];this.tabs=[...this.querySelectorAll('[data-slide]')];this.tabs.forEach((t,i)=>t.dataset.slide=i);this.index=0;this.paused=this.dataset.autoplay!=='true'||Boolean(window.Shopify?.designMode)||matchMedia('(prefers-reduced-motion: reduce)').matches;this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});
 on(this,'click',e=>{const b=e.target.closest('button,a');if(!b)return;if(b.hasAttribute('data-slide')){this.select(Number(b.dataset.slide));this.stop();}if(b.hasAttribute('data-prev')){this.select((this.index-1+this.cards.length)%this.cards.length);this.stop();}if(b.hasAttribute('data-next')){this.select((this.index+1)%this.cards.length);this.stop();}if(b.hasAttribute('data-pause')){this.paused=!this.paused;this.pauseLabel();}if(b.hasAttribute('data-detail'))this.detail(b.closest('.sv2-card'));if(b.hasAttribute('data-close'))b.closest('dialog').close();if(b.hasAttribute('data-quiz')){this.resetQuiz();this.querySelector('[data-quiz-dialog]').showModal();}if(b.hasAttribute('data-restart'))this.resetQuiz();if(b.hasAttribute('data-shop'))this.track('silhouette_shop_click',b.dataset.style||'all');});
 this.querySelectorAll('dialog').forEach(d=>on(d,'click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
 on(this.querySelector('form'),'submit',e=>{e.preventDefault();this.results(new FormData(e.target));});

 const stage=this.querySelector('.sv2-stage');
 let gesture=null;
 const clearGesture=()=>{gesture=null;stage.classList.remove('is-dragging');stage.style.removeProperty('--sv2-drag');};
 on(stage,'pointerdown',e=>{
   if(!e.isPrimary||e.button!==0||this.cards.length<2)return;
   gesture={id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,horizontal:false};
   this.stop();
   stage.setPointerCapture(e.pointerId);
 });
 on(stage,'pointermove',e=>{
   if(!gesture||e.pointerId!==gesture.id)return;
   const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
   if(!gesture.horizontal&&Math.abs(dy)>12&&Math.abs(dy)>Math.abs(dx)){clearGesture();return;}
   if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)*1.2)gesture.horizontal=true;
   gesture.dx=dx;
   if(gesture.horizontal){stage.classList.add('is-dragging');stage.style.setProperty('--sv2-drag',Math.max(-130,Math.min(130,dx))+'px');}
 });
 on(stage,'pointerup',e=>{
   if(!gesture||e.pointerId!==gesture.id)return;
   const {dx,horizontal}=gesture;
   clearGesture();
   if(stage.hasPointerCapture(e.pointerId))stage.releasePointerCapture(e.pointerId);
   if(horizontal&&Math.abs(dx)>=45)this.select((this.index+(dx<0?1:-1)+this.cards.length)%this.cards.length);
 });
 on(stage,'pointercancel',clearGesture);
 on(stage,'lostpointercapture',clearGesture);
 this.hover=false;on(this.querySelector('.sv2-hero'),'mouseenter',()=>this.hover=true);on(this.querySelector('.sv2-hero'),'mouseleave',()=>this.hover=false);
 if(this.cards.length){this.select(0);this.timer=setInterval(()=>{if(!this.paused&&!this.hover&&!document.hidden&&!this.querySelector('dialog[open]')&&!this.querySelector('.sv2-hero').contains(document.activeElement))this.select((this.index+1)%this.cards.length);},Number(this.dataset.speed)||6000);}this.pauseLabel();this.querySelectorAll('[data-js]').forEach(x=>x.hidden=this.cards.length===0);on(this,'shopify:block:select',e=>{const i=this.cards.indexOf(e.target.closest('.sv2-card'));if(i>=0){this.select(i);this.stop();}});
 }
 disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.ready=false;}
 track(event,style){if(Array.isArray(window.dataLayer))window.dataLayer.push({event,silhouette:style});this.dispatchEvent(new CustomEvent(event,{bubbles:true,detail:{silhouette:style}}));}
 stop(){this.paused=true;this.pauseLabel();}
 pauseLabel(){const b=this.querySelector('[data-pause]');b.querySelector('[data-play-icon]').hidden=!this.paused;b.querySelector('[data-pause-icon]').hidden=this.paused;b.querySelector('[data-play-icon]').toggleAttribute('hidden',!this.paused);b.querySelector('[data-pause-icon]').toggleAttribute('hidden',this.paused);b.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);}
 select(i){this.index=i;const c=this.cards[i];if(!c)return;const stage=this.querySelector('.sv2-stage');stage.replaceChildren();const cap=c.querySelector('.sv2-cap');if(cap){const img=cap.cloneNode();img.className='';img.loading='eager';stage.append(img);}const a=this.querySelector('[data-hero-link]');const href=c.querySelector('[data-shop]').getAttribute('href');if(href)a.setAttribute('href',href);else a.removeAttribute('href');a.dataset.style=c.dataset.name;this.querySelector('[data-hero-name]').textContent=c.dataset.name;this.querySelector('[data-hero-fit]').textContent=c.dataset.fit;this.tabs.forEach((t,n)=>t.setAttribute('aria-pressed',String(n===i)));const selected=this.tabs[i],rail=this.querySelector('.sv2-tabs');if(selected&&rail.clientWidth){rail.scrollLeft+=selected.getBoundingClientRect().left-rail.getBoundingClientRect().left-(rail.clientWidth-selected.offsetWidth)/2;}const tags=this.querySelector('[data-tags]');tags.replaceChildren();[c.dataset.fit,c.dataset.visor,c.dataset.crown].filter(Boolean).forEach(v=>{const s=document.createElement('span');s.textContent=v;tags.append(s);});}
 detail(c){const d=this.querySelector('[data-detail-dialog]');d.querySelector('h2').textContent=c.dataset.name;const holder=d.querySelector('[data-detail-image]');holder.replaceChildren();const cap=c.querySelector('.sv2-cap');if(cap)holder.append(cap.cloneNode());d.querySelector('[data-description]').textContent=c.dataset.description;['fit','visor','crown','profile'].forEach(k=>d.querySelector('[data-spec='+k+']').textContent=c.dataset[k]);const a=d.querySelector('[data-shop]');const href=c.querySelector('[data-shop]').getAttribute('href');if(href)a.setAttribute('href',href);else a.removeAttribute('href');a.dataset.style=c.dataset.name;a.textContent=this.dataset.shop+' '+c.dataset.name;d.showModal();this.track('silhouette_detail_view',c.dataset.name);}
 resetQuiz(){const d=this.querySelector('[data-quiz-dialog]');d.querySelector('form').reset();d.querySelector('form').hidden=false;d.querySelector('[data-results]').hidden=true;}
 results(fd){const fit=fd.get('closure'),shape=fd.get('shape');const ranked=this.cards.map((c,i)=>{let score=0;if(fit==='any')score+=1;else if(fit==='fitted'&&c.dataset.closure==='fitted')score+=4;else if(fit==='stretch'&&['stretch','both'].includes(c.dataset.closure))score+=4;else if(fit==='adjustable'&&['adjustable','both'].includes(c.dataset.closure))score+=4;if(shape==='any')score+=1;else if(shape==='flat'&&c.dataset.shape==='flat')score+=3;else if(shape==='curved'&&c.dataset.shape==='curved')score+=3;else if(shape==='relaxed'&&c.dataset.shape==='relaxed')score+=3;return {c,score,i};}).sort((a,b)=>b.score-a.score||a.i-b.i).slice(0,2);const d=this.querySelector('[data-quiz-dialog]'),out=d.querySelector('.sv2-quiz-results');out.replaceChildren();ranked.forEach(({c})=>{const el=document.createElement('div');el.className='sv2-result';const im=c.querySelector('.sv2-cap')?.cloneNode()||document.createElement('span');const h=document.createElement('h3');h.textContent=c.dataset.name;const p=document.createElement('p');p.textContent=c.dataset.fit+' · '+c.dataset.visor+' · '+c.dataset.crown;const a=c.querySelector('[data-shop]').cloneNode(true);a.className='sv2-btn';el.append(im,h,p,a);out.append(el);});d.querySelector('form').hidden=true;d.querySelector('[data-results]').hidden=false;d.querySelector('[data-result-title]').focus();this.track('silhouette_finder_complete',ranked.map(x=>x.c.dataset.name).join(', '));}
}
customElements.define('sv2-silhouette-v2',NESilhouetteGuide);
}


  } catch(e) { console.error(e); }
})();
})();
